<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.BabyHeight.title') }}</span>
      <span class="fmt-spacer"/>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>

    <!-- Input -->
    <div class="bh-inputs">
      <div class="bh-field">
        <span class="bh-field-lbl">{{ $t('tool.BabyHeight.father') }}</span>
        <div class="bh-input-row">
          <input class="bh-input" v-model="father" placeholder="175" @input="calc" spellcheck="false"/>
          <span class="bh-unit">cm</span>
        </div>
      </div>
      <div class="bh-field">
        <span class="bh-field-lbl">{{ $t('tool.BabyHeight.mother') }}</span>
        <div class="bh-input-row">
          <input class="bh-input" v-model="mother" placeholder="160" @input="calc" spellcheck="false"/>
          <span class="bh-unit">cm</span>
        </div>
      </div>
    </div>

    <!-- Result -->
    <template v-if="result">
      <div class="bh-cards">
        <div class="bh-card bh-boy">
          <div class="bh-card-icon">♂</div>
          <div class="bh-card-title">{{ $t('tool.BabyHeight.boyShort') }}</div>
          <div class="bh-card-val">{{ result.boy }} <span>cm</span></div>
          <div class="bh-card-range">{{ result.boyMin }} ~ {{ result.boyMax }} cm</div>
        </div>
        <div class="bh-card bh-girl">
          <div class="bh-card-icon">♀</div>
          <div class="bh-card-title">{{ $t('tool.BabyHeight.girlShort') }}</div>
          <div class="bh-card-val">{{ result.girl }} <span>cm</span></div>
          <div class="bh-card-range">{{ result.girlMin }} ~ {{ result.girlMax }} cm</div>
        </div>
      </div>

      <!-- Height comparison bars -->
      <div class="bh-compare">
        <div class="bh-compare-title">{{ $t('tool.BabyHeight.compare') }}</div>
        <div class="bh-bars">
          <div class="bh-bar-row">
            <span class="bh-bar-lbl">{{ $t('tool.BabyHeight.fatherShort') }}</span>
            <div class="bh-bar-track"><div class="bh-bar-fill bh-fill-dad" :style="{width:pct(father)+'%'}"/></div>
            <span class="bh-bar-num">{{ father }}</span>
          </div>
          <div class="bh-bar-row">
            <span class="bh-bar-lbl">{{ $t('tool.BabyHeight.motherShort') }}</span>
            <div class="bh-bar-track"><div class="bh-bar-fill bh-fill-mom" :style="{width:pct(mother)+'%'}"/></div>
            <span class="bh-bar-num">{{ mother }}</span>
          </div>
          <div class="bh-bar-row">
            <span class="bh-bar-lbl">{{ $t('tool.BabyHeight.boyShort') }}</span>
            <div class="bh-bar-track"><div class="bh-bar-fill bh-fill-boy" :style="{width:pct(result.boy)+'%'}"/></div>
            <span class="bh-bar-num">{{ result.boy }}</span>
          </div>
          <div class="bh-bar-row">
            <span class="bh-bar-lbl">{{ $t('tool.BabyHeight.girlShort') }}</span>
            <div class="bh-bar-track"><div class="bh-bar-fill bh-fill-girl" :style="{width:pct(result.girl)+'%'}"/></div>
            <span class="bh-bar-num">{{ result.girl }}</span>
          </div>
        </div>
      </div>
    </template>

    <div class="fmt-status-bar">
      <span v-if="result" class="fmt-hint">{{ $t('tool.BabyHeight.formulaHint') }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.BabyHeight.hint') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'BabyHeightTool',
  props:{ config:{ type:Object, default:function(){ return {} } } },
  data:function(){ return { father:'', mother:'', result:null } },
  methods:{
    calc:function(){
      var f = parseFloat(this.father), m = parseFloat(this.mother)
      if (!f || !m || f < 100 || f > 250 || m < 100 || m > 250) { this.result = null; return }
      var boy = (f + m + 13) / 2, girl = (f + m - 13) / 2
      this.result = {
        boy:boy.toFixed(1), boyMin:(boy-5).toFixed(1), boyMax:(boy+5).toFixed(1),
        girl:girl.toFixed(1), girlMin:(girl-5).toFixed(1), girlMax:(girl+5).toFixed(1)
      }
    },
    pct:function(val){ return Math.min(100, Math.max(0, (parseFloat(val) / 210) * 100)) },
    clearAll:function(){ this.father = ''; this.mother = ''; this.result = null },
    doAction:function(a){ if (a === 'clear') this.clearAll() }
  }
}
</script>

<style scoped>
.fmt-tool{display:flex;flex-direction:column;gap:16px;max-width:100%}

.fmt-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.fmt-toolbar >>> .el-button + .el-button{margin-left:0}
.fmt-label{font-size:13px;font-weight:700;color:#1a1f36}
.fmt-spacer{flex:1}

/* 输入 */
.bh-inputs{display:flex;gap:16px}
.bh-field{flex:1;min-width:0;background:#fafbfc;border:1px solid #ebeef5;border-radius:12px;padding:18px 20px}
.bh-field-lbl{display:block;font-size:12px;font-weight:700;color:#909399;margin-bottom:10px}
.bh-input-row{display:flex;align-items:center;gap:8px}
.bh-input{flex:1;min-width:0;border:1.5px solid #e1e5e9;border-radius:10px;padding:12px 16px;font-size:22px;font-family:'SF Mono',Menlo,Consolas,monospace;text-align:center;outline:none;color:#1a1f36;background:#fff;transition:.15s}
.bh-input:focus{border-color:#4e7cff;box-shadow:0 0 0 3px rgba(78,124,255,.06)}
.bh-input::placeholder{color:#d0d4dc;font-size:16px}
.bh-unit{font-size:13px;color:#b0b8c4;font-weight:600}

/* 结果卡片 */
.bh-cards{display:flex;gap:16px}
.bh-card{flex:1;text-align:center;border-radius:14px;padding:28px 20px;border:1px solid}
.bh-boy{background:linear-gradient(135deg,#e8f0fe,#f4f8ff);border-color:#d0ddf5}
.bh-girl{background:linear-gradient(135deg,#fde8f0,#fef4f8);border-color:#f0d0e0}
.bh-card-icon{font-size:28px;margin-bottom:4px}
.bh-card-title{font-size:12px;font-weight:600;color:#909399;margin-bottom:8px}
.bh-boy .bh-card-title{color:#4e7cff}
.bh-girl .bh-card-title{color:#e8508a}
.bh-card-val{font-size:40px;font-weight:700;color:#1a1f36;line-height:1.1}
.bh-card-val span{font-size:14px;font-weight:400;color:#909399}
.bh-card-range{font-size:12px;color:#b0b8c4;margin-top:6px}

/* 对比条 */
.bh-compare{background:#fff;border:1px solid #ebeef5;border-radius:12px;padding:18px 20px}
.bh-compare-title{font-size:13px;font-weight:700;color:#303133;margin-bottom:12px}
.bh-bars{display:flex;flex-direction:column;gap:8px}
.bh-bar-row{display:flex;align-items:center;gap:10px}
.bh-bar-lbl{font-size:12px;font-weight:600;color:#606266;width:36px;flex-shrink:0}
.bh-bar-track{flex:1;height:16px;background:#f0f2f5;border-radius:8px;overflow:hidden}
.bh-bar-fill{height:100%;border-radius:8px;transition:width .3s}
.bh-fill-dad{background:#7c9af2}
.bh-fill-mom{background:#e8508a}
.bh-fill-boy{background:#4e7cff}
.bh-fill-girl{background:#e8508a}
.bh-bar-num{font-size:12px;font-weight:600;color:#303133;width:50px;text-align:right}

.fmt-status-bar{font-size:12px}
.fmt-hint{color:#c0c4cc;line-height:1.6}

@media(max-width:480px){.bh-inputs,.bh-cards{flex-direction:column}}
</style>
